export default {
  'contactCenter.someNotEligible': 'Some payees are not eligible for approval',
  'contactCenter.addSuccessMessage': 'Contacts successfully created',
  'contactCenter.addFailMessage': 'Contacts were not created',
  'contactCenter.deleteWarning': 'Delete Payee',
  'contactCenter.content': 'The following payee is about to be deleted',
  'contactCenter.singleDeleteErrorTitle':
    '<%= count %> payments pending for this Payee. <%= name %> cannot be deleted at this time.',
  'contactCenter.multiDeleteErrorTitle':
    'Some payees ineligible to be deleted due to pending payments',
  'contactCenter.successDeleteTitle': 'Payee Deleted',

  'contactCenter.grid.savedViews.allPayees': 'All Payees',
  'contactCenter.grid.savedViews.filter.containsApproval': 'Contains Requires My Approval',
  'contactCenter.grid.savedViews.requiresMyApproval': 'Requires My Approval'
};
